import { generatePKCECodes } from "./client-utils/generatePKCECodes";
import { buildLoginURL } from "./redirect";

// This function initiates the login process for customer accounts
export const getLoginUrl = async () => {
  // Generate PKCE codes and store them in localStorage
  const { codeVerifier, codeChallenge, state, nonce } = await generatePKCECodes();

  // Check if the PKCE codes were generated successfully
  if (!codeVerifier || !codeChallenge || !state || !nonce) {
    return { error: "Login initiation failed: Missing required parameters." };
  }
  // Store the PKCE codes and state in localStorage for later use
  localStorage.setItem("code-verifier", codeVerifier);
  localStorage.setItem("state", state);
  localStorage.setItem("nonce", nonce);

  // Build the login URL using the generated PKCE codes and other parameters
  const loginURL = buildLoginURL(codeChallenge, state, nonce);
  return { loginURL };
};

// This function retrieves the logout URL for customer accounts
export const getLogoutUrl = async () => {
  try {
    // Make a request to the server to get the logout URL
    const response = await fetch("/api/auth/logout", { method: "GET" });

    // Check if the response is OK
    if (!response.ok) {
      // console.error("Server error:", response.status, response.statusText);
      return { error: "Logout failed. Please try again." };
    }

    // Parse the response to get the logout URL and error
    const data = await response.json();
    const { logoutURL, error } = data;

    // Check if the logout URL is present in the response
    if (logoutURL) {
      return { logoutURL };
    }

    // Handle the case where the logout URL is not found
    return { error: error || "Logout URL not found" };
  } catch (err) {
    // Handle network errors or unexpected issues
    // console.error("Logout error:", err);
    return { error: "Unexpected error during logout" };
  }
};

// This function handles the login process by redirecting the user to the login URL
export const handleShopifyLogin = async () => {
  // const isLoggedIn = await getLoginStatus();
  // if (isLoggedIn) {
  //   // User is already logged in, no need to redirect
  //   return;
  // }
  // Make a request to get the login URL
  const { loginURL, error } = await getLoginUrl();

  // Check if the login URL is present in the response
  if (!loginURL) {
    return { error: error || "Login URL not found" };
  }

  // Redirect the user to the login URL
  window.location.href = loginURL;
  return;
};

// This function handles the logout process by redirecting the user to the logout URL
export const handleShopifyLogout = async () => {
  // // Make a request to get the logout URL
  const { logoutURL, error } = await getLogoutUrl();

  // Check if the logout URL is present in the response
  if (logoutURL) {
    window.location.href = logoutURL;
    return;
  }
  // Handle the case where the logout URL is not found
  return { error: error || "Logout URL not found" };
};
